import type { BossDef } from './boss-base';

/**
 * B1 — Sentinel Orb. Tutorial boss: no weak point, takes damage anywhere.
 * Signature movement: slow orbit. 3 phases: aimed fans + rings →
 * counter-rotating double ring + drones → rage spiral. docs/02-bosses.md
 * Signatures: telegraphed fan (P1), COUNTER-RINGS (P2), rage spiral (P3).
 */
export const SENTINEL: BossDef = {
  id: 'sentinel',
  nameKey: 'boss.sentinel',
  tier: 1,
  baseHp: 800,
  radius: 78,
  bodyKey: 'boss/sentinel/body',
  ringKey: 'boss/sentinel/orbit-ring',
  movement: 'hover',
  contactDamage: 1,
  phases: [
    {
      // Phase 1 (100-60%): aimed 3-fan bursts + slow ring
      hpPct: 1.0,
      patterns: [
        {
          type: 'aimed', count: 3, spreadDeg: 26, interval: 1.7,
          telegraph: 0.45, burst: 2, burstGap: 0.3,
          bullet: 'bullet/enemy/bolt', speed: 230, radius: 11, damage: 1,
        },
        {
          type: 'radial', count: 16, interval: 2.9, spinDeg: 11, unlockTier: 1,
          bullet: 'bullet/enemy/bolt', speed: 130, radius: 11, damage: 1,
        },
      ],
    },
    {
      // Phase 2 (60-25%): nested counter-rotating rings + drone call
      hpPct: 0.6,
      patterns: [
        {
          type: 'radial', count: 14, interval: 2.4, spinDeg: 9,
          bullet: 'bullet/enemy/bolt', speed: 150, radius: 11, damage: 1,
        },
        {
          type: 'radial', count: 14, interval: 2.4, spinDeg: -9, phaseDeg: 13,
          bullet: 'bullet/enemy/ring', speed: 110, radius: 11, damage: 2,
        },
        {
          type: 'aimed', count: 3, spreadDeg: 22, interval: 2.1,
          telegraph: 0.4, unlockTier: 1,
          bullet: 'bullet/enemy/bolt', speed: 250, radius: 11, damage: 1,
        },
      ],
      spawnDrones: 2,
    },
    {
      // Phase 3 (25-0%): rage — spiral + fast fan, tempo 1.5x
      hpPct: 0.25,
      speedMul: 1.5,
      patterns: [
        {
          type: 'spiral', arms: 2, interval: 0.11, angularSpeed: 85,
          bullet: 'bullet/enemy/ring', speed: 160, radius: 11, damage: 2,
        },
        {
          type: 'aimed', count: 5, spreadDeg: 42, interval: 2.3,
          telegraph: 0.4, burst: 2, burstGap: 0.35, unlockTier: 1,
          bullet: 'bullet/enemy/bolt', speed: 270, radius: 11, damage: 1,
        },
      ],
    },
  ],
  evolve: [
    {
      // Orbit halo: the ring sprite sheds slow heavy beads
      tier: 2,
      pattern: {
        type: 'radial', count: 8, interval: 4.2, spinDeg: 22,
        bullet: 'bullet/enemy/ring', speed: 95, radius: 11, damage: 2,
      },
    },
    {
      // Sniper eye: a quick single-shot burst once the shell cracks
      tier: 3,
      fromPhase: 1,
      pattern: {
        type: 'aimed', count: 1, spreadDeg: 0, interval: 3.4,
        telegraph: 0.5, burst: 3, burstGap: 0.16,
        bullet: 'bullet/enemy/bolt', speed: 310, radius: 10, damage: 1,
      },
    },
  ],
};
